import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import moment from "moment";
import "moment/locale/zh-cn";

// ElementUI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// 自定义样式
import "@/assets/styles/main.scss";

// 全局过滤器
import "@/utils/filters";

// 权限控制
import "@/permission";

// 设置moment.js使用中文
moment.locale("zh-cn");

Vue.use(ElementUI, { size: "medium", zIndex: 10000 });

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
